import BaseShopLayout from "@shop/components/BaseShopLayout";
import AIServiceSelection from "@shop/components/AIServiceSelection";
import { Typography } from "@mui/material";

const AIServiceShopPage = () => {
    return (
        <BaseShopLayout
            title={"Hier findest Du unsere KI-Services – einfach, schnell und präzise."}
            description={
                <Typography variant="body1" color="text.secondary" align="center">
                    <strong>Für noch mehr Effizienz:</strong>
                    <br />
                    Unsere spezialisierten KI-Services automatisieren zentrale Prozesse
                    <br />
                    und bringen Tempo in Ihre ESG-Arbeit.
                </Typography>
            }
            useOuterScroll
        >
            <AIServiceSelection />
        </BaseShopLayout>
    );
};

export default AIServiceShopPage;
